import { Action } from "@ngrx/store";

export const GET_CATEGORIES_LIST = '[Categories] Get Categories List';
export const GET_CATEGORIES_LIST_SUCCESS = '[Categories] Get Categories List Success';
export const GET_CATEGORIES_LIST_FAIL = '[Categories] Get Categories List Fail';
export const CLEAR_CATEGORIES_LIST = '[Categories] Clear Categories List';

export class GetCategoriesList implements Action {
  readonly type = GET_CATEGORIES_LIST;
  constructor(public payload: { institutionId: number } = null) { }
}

export class GetCategoriesSuccess implements Action {
  readonly type = GET_CATEGORIES_LIST_SUCCESS;
  constructor(public payload: any = null) { }
}

export class GetCategoriesListFail implements Action {
  readonly type = GET_CATEGORIES_LIST_FAIL;
  constructor(public payload: any = null) { }
}

export class ClearCategoriesList implements Action {
  readonly type = CLEAR_CATEGORIES_LIST;
  constructor(public payload: any = null) { }
}

export type CategoriesActions =
  | GetCategoriesList
  | GetCategoriesSuccess
  | GetCategoriesListFail
  | ClearCategoriesList;